import { render, staticRenderFns } from "./SalesFollowups.vue?vue&type=template&id=0aa81e6a&scoped=true"
import script from "./SalesFollowups.vue?vue&type=script&lang=js"
export * from "./SalesFollowups.vue?vue&type=script&lang=js"
import style0 from "./SalesFollowups.vue?vue&type=style&index=0&id=0aa81e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa81e6a",
  null
  
)

export default component.exports